<!--师资培训-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--标签页：培训任务/培训课程-->
            <div class="tab-row">
                <tea-train-menu :item-num="this.activeItem"
                                @change-item="changeItem"/>
            </div>
            <div class="module-content">
                <!--任务-->
                <tea-train-task v-if="activeItem==='2'"
                                :course-mode="this.activeMode"
                                @change-mode="changeMode"/>
                <!--课程-->
                <page-train-course v-if="activeItem==='3'"
                                   title="培训课程"
                                   courseType="1"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import teaTrainMenu from "@/components/teaTrain/teaTrainMenu.vue";
import teaTrainStat from "@/components/teaTrain/teaTrainStat.vue";
import teaTrainTask from "@/components/teaTrain/teaTrainTask.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import pageTrainCourse from "@/components/teaTrain/pageTrainCourse.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";
export default {
    components: {
        pageCourse,
        eduUserLesson,
        dataEmpty,
        homeHead,
        teaTrainMenu,
        teaTrainStat,
        teaTrainTask,
        pageTrainCourse,
    },
    name: "homeEduResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "teacherTrainCenter",
            activeItem:"2",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
</style>